export const appHead = {"meta":[{"charset":"utf-8"},{"name":"viewport","content":"width=device-width, initial-scale=1"}],"link":[{"rel":"dns-prefetch","href":"https://sw6.mysofabed.de"},{"rel":"preconnect","href":"https://sw6.mysofabed.de","crossorigin":""},{"rel":"preload","as":"font","href":"/fonts/Mulish/Mulish-Variable.woff2","type":"font/woff2","crossorigin":"anonymous","tagPriority":-5},{"rel":"preload","as":"font","href":"/fonts/Marcellus/Marcellus-Regular.woff2","type":"font/woff2","crossorigin":"anonymous","tagPriority":-5},{"rel":"icon","type":"image/png","sizes":"48x48","href":"/favicon-48x48.png","tagPriority":-5},{"rel":"icon","type":"image/png","sizes":"96x96","href":"/favicon-96x96.png","tagPriority":-5},{"rel":"shortcut icon","href":"/favicon.ico","tagPriority":-5},{"rel":"preload","as":"font","href":"/fonts/icons/icomoon.woff2","type":"font/woff2","crossorigin":"anonymous","tagPriority":-5}],"style":[{"innerHTML":"@font-face{font-family:\"icomoon\";src:url(\"/fonts/icons/icomoon.woff2\") format(\"woff2\");font-weight:normal;font-style:normal;font-display:swap;}@font-face{font-family:\"Mulish\";src:url(\"/fonts/Mulish/Mulish-Variable.woff2\") format(\"woff2\");font-weight:300 700;font-style:normal;font-display:swap;ascent-override:103.9%;descent-override:27%;line-gap-override:0%;}@font-face{font-family:\"Marcellus\";src:url(\"/fonts/Marcellus/Marcellus-Regular.woff2\") format(\"woff2\");font-weight:400;font-style:normal;font-display:swap;}"}],"script":[],"noscript":[],"htmlAttrs":{"lang":"de"}}

export const appPageTransition = {"name":"page","mode":"out-in"}

export const appKeepalive = true

export const appBaseURL = "/"

export const appBuildAssetsDir = "/_nuxt/"

export const appCdnURL = ""

export const appLayoutTransition = false

export const appViewTransition = false

export const appRootId = "__nuxt"

export const appRootTag = "div"

export const appRootAttrs = {"id":"__nuxt"}

export const appTeleportTag = "div"

export const appTeleportId = "teleports"

export const appTeleportAttrs = {"id":"teleports"}

export const appSpaLoaderTag = "div"

export const appSpaLoaderAttrs = {"id":"__nuxt-loader"}

export const renderJsonPayloads = true

export const componentIslands = false

export const payloadExtraction = true

export const cookieStore = true

export const appManifest = true

export const remoteComponentIslands = false

export const selectiveClient = false

export const devPagesDir = null

export const devRootDir = null

export const devLogs = false

export const nuxtLinkDefaults = {"componentName":"NuxtLink","prefetch":true,"prefetchOn":{"visibility":true}}

export const asyncDataDefaults = {"value":null,"errorValue":null,"deep":true}

export const resetAsyncDataToUndefined = true

export const nuxtDefaultErrorValue = null

export const fetchDefaults = {}

export const vueAppRootContainer = '#__nuxt'

export const viewTransition = false

export const appId = "nuxt-app"

export const outdatedBuildInterval = 3600000

export const multiApp = false

export const chunkErrorEvent = "vite:preloadError"

export const crawlLinks = false

export const spaLoadingTemplateOutside = false

export const purgeCachedData = true

export const granularCachedData = false

export const pendingWhenIdle = true

export const alwaysRunFetchOnKeyChange = true